"use client";
import React from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";

const LogoLink: React.FC = () => {
  return (
    <Link
      href="/"
      aria-label="返回首页"
      className="flex items-center gap-2 transition-opacity focus:outline-none"
    >
      <img src="/img/favicon.png" alt="元渊智能" className="h-8 w-8" />
      <span className="font-semibold text-lg">元渊智能</span>
    </Link>
  );
};

export default LogoLink;
